import React from 'react';

/**
 * 资产分析对话框的骨架屏组件
 */
export const SkeletonDashboard: React.FC = () => (
  <div className="space-y-4">
    {[1, 2, 3].map(i => (
      <div key={i} className="rounded-lg bg-gray-100 p-3">
        <div className="mb-2 flex items-center justify-between">
          <div className="h-4 w-20 rounded bg-gray-200" />
          <div className="h-4 w-16 rounded bg-gray-200" />
        </div>
        <div className="mb-2 h-4 w-full rounded bg-gray-200" />
        <div className="h-12 w-full rounded bg-gray-200" />
      </div>
    ))}
  </div>
);
